import { suggestionText, isEditing, indexOfType, isInAlarmAgent } from "../common/common"
import { createAction, setterAction } from "../common/redux"
import tracker from "../common/tracker"
import * as t from "./actionTypes"

import * as interviewActions from "../interview/actions"
import * as completionActions from "../completion/actions"
import {
  setFollowUpSubmitted,
  setSpecialistSuggestion,
  showPostIntentPopUp,
  setDiagnosisConcern,
} from "../feedback/actions"
import Source from "../interview/Source"
import { takeSnapshot } from "../redux/actions"
import * as generator from "../chatItemGenerator"
import { captureException } from "../common/error"
import { SPECIALIST, OTHER } from "./constants"
import {
  setSpecialist,
  setDiagnosisConcernSearch,
} from "../integration/actions"
import { dConcernHeader } from "../feedback/optimize"
import { coronavirusSearch } from "../integration/utils"
import { messages } from "../chatItemGenerator"

let smallTextSize = 3

export const setSearchMsg = setterAction(t.SET_SEARCH_MSG)
export const setSearchActive = setterAction(t.SET_SEARCH_ACTIVE)
export const setFinishedInputtingSymptoms = setterAction(
  t.SET_FINISHED_INPUTTING_SYMPTOMS
)
export const setSuggestionLoading = setterAction(t.SET_SUGGESTION_LOADING)
export const setSearchAttempted = setterAction(t.SET_SEARCH_ATTEMPTED)
export const setSearchSuggestions = setterAction(t.SET_SEARCH_SUGGESTIONS)
export const setSearchResults = setterAction(t.SET_SEARCH_RESULTS)
export const incrementAutosuggestSequence = createAction(
  t.INCREMENT_AUTOSUGGEST_SEQUENCE
)
export const incrementActiveSuggestion = createAction(t.INCREMENT_SUGGESTION)
export const decrementActiveSuggestion = createAction(t.DECREMENT_SUGGESTION)
export const setSearch = setterAction(t.SET_SEARCH)
export const setCachedSearch = setterAction(t.SET_CACHED_SEARCH)
export const setHeader = setterAction(t.SET_HEADER)
export const setItemText = createAction(t.SET_ITEM_TEXT, "text", "index")
export const setItemFinished = createAction(
  t.SET_ITEM_FINISHED,
  "finished",
  "index"
)
export const setCachedHeader = createAction(
  t.SET_CACHED_HEADER,
  "cachedHeader",
  "index"
)
export const setSubmitted = setterAction(t.SET_SUBMITTED)
export const setUserIntent = setterAction(t.SET_USER_INTENT)
export const setUserIntentCareOption = setterAction(
  t.SET_USER_INTENT_CARE_OPTION
)

export const executeSearch = () => (dispatch, getState) => {
  let { search } = getState().search
  let { seq } = getState().search.suggestions

  dispatch(incrementAutosuggestSequence())

  if (!search || !search.length) return

  Source.searchAutocomplete(search, seq)
    .then(data => {
      window.searchRetrys = 0
      dispatch(setSuggestionLoading(false))
      if (data.suggestions) {
        dispatch(
          setSearchSuggestions(
            data.suggestions.map(s => ({
              index: s[0],
              text: typeof s[1] === "string" ? s[1] : s[1].join(", "),
              token: s[1],
            }))
          )
        )
      } else {
        dispatch(setSearchSuggestions([]))
      }
    })
    .catch(error => {
      console.log("Error submitting free text search")
      console.log(error)
      captureException(error)
      dispatch(setSearchSuggestions([]))
      if (!window.searchRetrys) window.searchRetrys = 0

      if (window.searchRetrys < 3) {
        window.searchTimer = setTimeout(() => {
          console.log("resubmitting search")
          window.searchRetrys += 1
          dispatch(executeSearch())
        }, 1000)
      }
    })
}

export const suggestionClicked = index => (dispatch, getState) => {
  let { items } = getState().search.suggestions

  dispatch(interpretSearch(items[index].text))
}

export const interpretSearch = query => (dispatch, getState) => {
  if (!query) {
    return
  }

  takeSnapshot("filter")
  dispatch(interviewActions.setInterviewStarted(false))
  dispatch(setFinishedInputtingSymptoms(false))

  dispatch(setSearch(query))
  dispatch(setSearchSuggestions([]))
  dispatch(interviewActions.setSubmissionQueue([]))

  tracker.suggestionClicked()

  Source.interpretSearch(query)
    .then(data => {
      let { search } = getState().search
      // do not set clarifiers if search has been cleared
      if (data.clarifiers && search.length > 0) {
        //dispatch(interviewActions.processClarifier(data))
        dispatch(
          setSearchResults({
            items: data.clarifiers.map(s => ({
              title: s.title,
              description: s.description,
              token: s.token,
            })),
          })
        )
      } else if (data.status === 204) {
        dispatch(setSearchResults({ status: 204 }))
      }
    })
    .catch(error => {
      captureException(error)
      console.log("Error retrieving search interpretation")
      console.log(error)
    })
}

// submitClarifier will replace submitAnswer action
// interacts with new /search/clarify/ endpoint instead of /visit/submit_answer/
export const submitClarifier = (token, title) => (dispatch, getState) => {
  let { editor, chatList } = getState()

  tracker.clarifierClicked()
  Source.submitClarifier(token)
    .then(data => {
      dispatch(interviewActions.processQuestionResponse(data))

      // Reset previous search state
      dispatch(setSearchAttempted(false))

      if (editor.isActive && chatList.interviewStarted) {
        dispatch(interviewActions.diagRanksAndPredInfo())
      }

      dispatch(setHeader({ filter: title, clarifier: null }))

      let sbIndex = chatList.items.findIndex(
        item => item.type === "symptomBubble" && !item.finished
      )
      dispatch(setItemText(title, sbIndex))
    })
    .catch(error => {
      console.log("Error submitting clarifier")
      captureException(error)
      // This is to catch the event where the server times out while processing a
      // completed visit and doesn't get the information back to the front in time,
      // instead returning a 504, which causes the front to retry answer submission
      // on a closed visit, causing a 403.
      if (error.response && error.response.status === 403) {
        return dispatch(completionActions.complete())
      }
      dispatch(interviewActions.genericError(error))
    })
}

export const searchChange = (text, suggestions = []) => (
  dispatch,
  getState
) => {
  let { attempted } = getState().search
  // Tracking if the user made an attempt to search anything by recording the
  // first instance of typing
  if (!attempted && text.length) {
    tracker.searchAttempted()
    dispatch(setSearchAttempted(true))
  }

  dispatch(setSearch(text))
  dispatch(setSearchSuggestions(suggestions))
  dispatch(setSearchResults([]))
  dispatch(setSearchMsg(""))
  if (text.length >= smallTextSize) {
    clearTimeout(window.searchTimer)
    dispatch(setSuggestionLoading(true))

    dispatch(executeSearch())

    // if a user stops typing for 2 seconds, we assume they stopped search
    // and are awaiting for suggestions or reading suggestions but if they
    // clicked on a suggestion at that point, don't record
    window.searchTimer = setTimeout(() => {
      let { active, suggestions } = getState().search
      if (active) {
        tracker.lookingAtSuggestions(suggestions.items.length)
      }
    }, 1500)
  } else if (suggestions.length === 0) {
    dispatch(setSearchSuggestions([{ text, token: "PLACEHOLDER", index: 0 }]))
  }
}

export const submitActiveLayterm = () => (dispatch, getState) => {
  let index = getState().search.suggestions.active
  if (index < 0) {
    index = 0
  }
  dispatch(submitLayterms(index))
}

export const cacheActiveLayterm = () => (dispatch, getState) => {
  let index = getState().search.suggestions.active
  if (index < 0) {
    index = 0
  }
  dispatch(cacheLayterm(index))
}

export const cacheLayterm = index => (dispatch, getState) => {
  let { loading } = getState()
  let { suggestions } = getState().search

  if (
    loading ||
    !suggestions.items[index] ||
    suggestions.items[index].token === "PLACEHOLDER"
  )
    return

  dispatch(setCachedSearch(suggestions.items[index].token))
  dispatch(setSearch(""))
  dispatch(setSearchSuggestions([]))
  tracker.suggestionClicked()
  if (window.search_first_ab_test) {
    let { account } = getState()
    dispatch(setItemText(suggestions.items[index].text, 1))
    dispatch(setItemFinished(true, 1))
    dispatch(
      interviewActions.addChatItem(generator.identityQues(account.profiles))
    )
  }
}

export const submitLayterms = index => (dispatch, getState) => {
  let { chatList, identifiers, loading } = getState()
  let { suggestions, search } = getState().search
  let { pov } = identifiers

  if (
    loading ||
    !suggestions.items[index] ||
    suggestions.items[index].token === "PLACEHOLDER"
  )
    return

  takeSnapshot("filter")
  dispatch(interviewActions.setInterviewStarted(false))
  dispatch(interviewActions.setLoading(true, "search/submitLayterms"))
  dispatch(setFinishedInputtingSymptoms(false))

  let activeItem = chatList.items[chatList.active]

  if (isEditing(chatList.items, chatList.active)) {
    activeItem.newResponse = index
    let filteredIndex = indexOfType(chatList.items, activeItem)
    let deletionIndices = []
    tracker.editSearch()
    return Source.getItems()
      .then(data => {
        let typeSeen = 0
        data.meta.forEach((x, i) => {
          if (x === "SEARCH" && typeSeen++ === filteredIndex) {
            deletionIndices.push(i)
          }
        })
        return Promise.all(deletionIndices.map(i => Source.deleteItem(i)))
      })
      .then(() => {
        dispatch(interviewActions.setLoading(false))
        dispatch(interviewActions.deleteChatItems())
        let activeItem = chatList.items[chatList.active]
        if (
          activeItem.type === "symptomBubble" &&
          activeItem.newResponse !== undefined
        ) {
          dispatch(submitLayterms(activeItem.newResponse))
        }
      })
      .catch(error => dispatch(interviewActions.genericError(error)))
  }

  let suggestion = suggestions.items[index].text
  let { before, during, after } = suggestionText(suggestion, search)

  let response = suggestions.items[index].token

  dispatch(setSearchActive(false))
  dispatch(setSearch(""))
  dispatch(setSearchSuggestions([]))
  dispatch(setSearchActive(false))
  dispatch(interviewActions.setSubmissionQueue([]))

  if (!search) {
    tracker.searchClicked()
  }

  tracker.suggestionClicked()

  Source.submitLayterms(
    typeof response === "string" ? response : response.join(";"),
    pov
  )
    .then(data => {
      dispatch(interviewActions.setLoading(false))
      chatList = getState().chatList
      let sbIndex = chatList.items.findIndex(
        item => item.type === "symptomBubble" && !item.finished
      )
      dispatch(interviewActions.setResponse(response))
      dispatch(setHeader({ filter: before + during + after, clarifier: null }))
      dispatch(setItemText(before + during + after, sbIndex))
      // Track event if this is a clarifier that actually needs answering, not an
      // auto submit set
      if (data.question && data.question.options.length === 1) {
        tracker.clarifierGiven()
      }

      dispatch(interviewActions.processClarifier(data.question))
    })
    .catch(error => {
      dispatch(interviewActions.setLoading(false))
      try {
        dispatch(setSearchMsg(error.response.data.msg))
      } catch (e) {
        dispatch(interviewActions.genericError(error))
      }
    })
}

// This is a temporary call to support pressing enter for the search bar
// that should be completely removed with the search rework
export const submitRawQuery = () => (dispatch, getState) => {
  let { chatList, identifiers, loading } = getState()
  let { search } = getState().search
  let { pov } = identifiers

  let text = search

  if (loading) return

  takeSnapshot("filter")
  dispatch(interviewActions.setInterviewStarted(false))
  dispatch(interviewActions.setLoading(true, "search/submitRawQuery"))
  dispatch(setFinishedInputtingSymptoms(false))

  let activeItem = chatList.items[chatList.active]

  if (isEditing(chatList.items, chatList.active)) {
    let filteredIndex = indexOfType(chatList.items, activeItem)
    let deletionIndices = []
    tracker.editSearch()
    return Source.getItems()
      .then(data => {
        let typeSeen = 0
        data.meta.forEach((x, i) => {
          if (x === "SEARCH" && typeSeen++ === filteredIndex) {
            deletionIndices.push(i)
          }
        })
        return Promise.all(deletionIndices.map(i => Source.deleteItem(i)))
      })
      .then(() => {
        dispatch(interviewActions.setLoading(false))
        dispatch(interviewActions.deleteChatItems())
        let activeItem = chatList.items[chatList.active]
        if (
          activeItem.type === "symptomBubble" &&
          activeItem.newResponse !== undefined
        ) {
          dispatch(submitLayterms(activeItem.newResponse))
        }
      })
      .catch(error => dispatch(interviewActions.genericError(error)))
  }

  dispatch(setSearchActive(false))
  dispatch(setSearch(""))
  dispatch(setSearchSuggestions([]))
  dispatch(setSearchActive(false))
  dispatch(interviewActions.setSubmissionQueue([]))

  if (!search) {
    tracker.searchClicked()
  }

  tracker.suggestionClicked()

  Source.submitLayterms(text, pov)
    .then(data => {
      dispatch(interviewActions.setLoading(false))
      chatList = getState().chatList
      let sbIndex = chatList.items.findIndex(
        item => item.type === "symptomBubble" && !item.finished
      )
      dispatch(interviewActions.setResponse(text))
      dispatch(setHeader({ filter: text, clarifier: null }))
      dispatch(setItemText(text, sbIndex))
      // Track event if this is a clarifier that actually needs answering, not an
      // auto submit set
      if (data.question.options.length === 1) {
        tracker.clarifierGiven()
      }

      dispatch(interviewActions.processClarifier(data.question))
    })
    .catch(error => {
      dispatch(interviewActions.setLoading(false))
      try {
        dispatch(setSearchMsg(error.response.data.msg))
      } catch (e) {
        dispatch(interviewActions.genericError(error))
      }
    })
}

export const addCachedSymptom = () => (dispatch, getState) => {
  let { header } = getState().search
  let { items } = getState().chatList
  let index = items.findIndex(
    item => item.type === "symptomBubble" && !item.finished
  )
  dispatch(setCachedHeader(header, index))
  dispatch(setItemFinished(true, index))
  dispatch(setHeader(""))
}

export const startInterview = () => (dispatch, getState) => {
  let { chatList, identifiers, loading } = getState()
  let { pov } = identifiers

  if (loading) return

  tracker.interviewStarted()

  dispatch(interviewActions.setLoading(true, "search/startInterview"))
  dispatch(setSearchActive(false))
  dispatch(setFinishedInputtingSymptoms(chatList.items.length))

  if (isEditing(chatList.items, chatList.active)) {
    let filteredIndex = indexOfType(
      chatList.items,
      chatList.items[chatList.active]
    )
    let deletionIndices = []
    tracker.editSearch()
    return Source.getItems()
      .then(data => {
        let typeSeen = 0
        data.meta.forEach((x, i) => {
          if (x === "SEARCH" && typeSeen++ >= filteredIndex) {
            deletionIndices.push(i)
          }
        })
        return Promise.all(deletionIndices.map(i => Source.deleteItem(i)))
      })
      .then(() => {
        dispatch(interviewActions.deleteChatItems())
        dispatch(interviewActions.setLoading(false))
        dispatch(startInterview())
      })
      .catch(error => dispatch(interviewActions.genericError(error)))
  }

  dispatch(interviewActions.setLoading(true, "search/startInterview 2"))
  if (window.skip_user_intent) {
    dispatch(resumeInterview())
  } else {
    window.searchTimer = setTimeout(() => {
      dispatch(interviewActions.setLoading(false))
      dispatch(interviewActions.addChatItem(generator.intentSeekingCare(pov)))
    }, 1000)
  }
}

const handlePotentialCompletion = dispatch => error => {
  // This is to catch the event where the server times out while processing a
  // completed visit and doesn't get the information back to the front in time,
  // instead returning a 504, which causes the front to retry closing input
  // on a closed visit, causing a 403.
  if (error.response && error.response.status === 403) {
    return dispatch(completionActions.complete())
  }
  dispatch(interviewActions.genericError(error))
}

export const processTutorials = data => (dispatch, getState) => {
  let { chatList, editor } = getState()
  if (data.results) {
    try {
      let parts = data.location.split("/")
      data.results["token"] = parts[parts.length - 1]
    } catch (e) {
      console.log("unable to read location")
      console.log(e)
    }
    return dispatch(
      completionActions.processResults(data.results, data.is_alarm)
    )
  }
  dispatch(interviewActions.processQuestionResponse(data))
  dispatch(
    interviewActions.setInterviewStarted(chatList.items[chatList.active])
  )
  if (editor.isActive) dispatch(interviewActions.diagRanksAndPredInfo())
  tracker.algoStarted()
}

export const seekingCareResponse = response => (dispatch, getState) => {
  let { identifiers, chatList } = getState()
  let { pov } = identifiers

  if (isEditing(chatList.items, chatList.active)) {
    dispatch(interviewActions.deleteChatItems())
  }

  dispatch(interviewActions.addChatItem(generator.response(response.text)))
  tracker.intentQuestionAnswered()
  if (response.token) {
    tracker.userFindingCare()
    Source.userIntentCareOptions()
      .then(data => {
        const options = data.options.map(option => {
          return {
            text: option.display,
            token: option.option,
          }
        })
        dispatch(
          interviewActions.addChatItem(
            generator.intentCareOptions(pov, options)
          )
        )
      })
      .catch(captureException)
  } else {
    tracker.userCheckingSymptoms()
    dispatch(saveUserIntent(false, null))
  }
}

export const careOptionResponse = response => (dispatch, getState) => {
  let { chatList, feedback } = getState()

  if (isEditing(chatList.items, chatList.active)) {
    dispatch(interviewActions.deleteChatItems())
  }

  dispatch(interviewActions.addChatItem(generator.response(response.text)))
  if (response.token === SPECIALIST) {
    dispatch(
      interviewActions.addChatItem(
        generator.specialistIntentCareOptions(
          feedback.followUp.specialistOptions
        )
      )
    )
  } else {
    dispatch(saveUserIntent(true, response.token))
  }
}

export const dxocPromptResponse = response => (dispatch, getState) => {
  let { identifiers } = getState()
  let { pov } = identifiers

  dispatch(interviewActions.addChatItem(generator.response(response.text)))
  dispatch(interviewActions.setLoading(true))
  // token can be 1 for yes and 0 for no
  if (response.token) {
    dispatch(
      interviewActions.addChatItems([
        generator.systemMessage(dConcernHeader(pov)),
        // TODO: Remove window variable after diagnosis of concern test
        generator.diagnosisConcern(window.d_concern_abcd === 4),
      ])
    )
  } else {
    dispatch(resumeInterview())
  }
}

export const specialistIntentCareOptions = response => (dispatch, getState) => {
  let { chatList } = getState()

  if (isEditing(chatList.items, chatList.active)) {
    dispatch(interviewActions.deleteChatItems())
  }

  dispatch(interviewActions.addChatItem(generator.response(response.text)))
  if (response.token === OTHER) {
    dispatch(interviewActions.addChatItem(generator.specialistSelect()))
  } else {
    dispatch(saveUserIntent(true, SPECIALIST, response.token))
  }
}

export const specialistInfoSubmit = (suggestion, postIntent) => (
  dispatch,
  getState
) => {
  const { integration } = getState()
  const { specialist } = integration

  if (suggestion) {
    postIntent
      ? dispatch(setSpecialistSuggestion(specialist.display))
      : dispatch(
          interviewActions.addChatItems([
            generator.systemMessage(
              `Your search for <b>"${specialist.display}"</b> did not match our list of specialists. We have noted your entry. Thank you for your feedback.`
            ),
          ])
        )
    dispatch(saveUserIntent(true, SPECIALIST, specialist.display, postIntent))
  } else {
    dispatch(saveUserIntent(true, SPECIALIST, specialist.name, postIntent))
  }
  if (!postIntent) {
    dispatch(setSpecialist({ display: "", name: "" }))
  }
}

export const diagnosisInfoSubmit = postVisit => (dispatch, getState) => {
  const { integration } = getState()
  const { diagnosisConcernSearch } = integration

  if (!diagnosisConcernSearch) {
    dispatch(saveDiagnosisConcern("", postVisit))
  } else {
    // TODO: CORONAVIRUS TECH DEBT, remove this if statement and replace with the else
    if (coronavirusSearch(diagnosisConcernSearch)) {
      dispatch(saveDiagnosisConcern("coronavirus", postVisit))
    } else {
      dispatch(saveDiagnosisConcern(diagnosisConcernSearch, postVisit))
    }
  }

  if (!postVisit) {
    dispatch(setDiagnosisConcernSearch(""))
  }
}

export const saveDiagnosisConcern = (diagnosisConcern, postVisit) => (
  dispatch,
  getState
) => {
  dispatch(
    interviewActions.addChatItem({
      type: "response",
      text: diagnosisConcern ? diagnosisConcern.toProperCase() : "Skip",
    })
  )
  diagnosisConcern = diagnosisConcern.toLowerCase()
  dispatch(interviewActions.setLoading(true))
  Source.getDiagnosisContentPage(diagnosisConcern)
    .then(payload => {
      let contentPage = ""
      if (payload.content.toString()) {
        contentPage = payload.content[0].url
      }
      dispatch(
        setDiagnosisConcern({
          display: diagnosisConcern,
          contentPage,
        })
      )
    })
    .catch(e => {
      captureException(e)
      dispatch(
        setDiagnosisConcern({
          display: diagnosisConcern,
          contentPage: "",
        })
      )
    })

  const resumeInterviewOrSkip = () => {
    if (!postVisit) {
      if (diagnosisConcern) {
        dispatch(
          interviewActions.addChatItem(
            generator.systemMessage(messages.interviewMessagesCoronaSymptoms)
          )
        )
      }
      dispatch(resumeInterview())
    }
  }

  Source.submitDiagnosisConcern(diagnosisConcern)
    .then(resumeInterviewOrSkip)
    .catch(e => {
      resumeInterviewOrSkip()
      captureException(e)
    })
}

export const resumeInterview = () => (dispatch, getState) => {
  const { feedback, brand, integration } = getState()
  const { diagnosisConcern } = feedback

  Source.startInterview()
    .then(data => {
      // TODO: CORONAVIRUS TECH DEBT, make this more dynamic or remove it
      if (
        data.question &&
        !isInAlarmAgent(data.question.question_context)
      ) {
        dispatch(interviewActions.setLoading(true))
        if (diagnosisConcern.display === "coronavirus") {
          if (brand.name === "public" || integration.configuredExperience) {
            diagnosisConcern.contentPage =
              "https://www.buoyhealth.com/diagnoses-a-z/coronavirus/"
          }
          tracker.dxocClose(diagnosisConcern.display)
          dispatch(
            interviewActions.addChatItem(
              generator.dxocClose("Coronavirus", diagnosisConcern.contentPage)
            )
          )
        }
      }
      dispatch(processTutorials(data))
    })
    .catch(handlePotentialCompletion(dispatch))
}

export const saveUserIntent = (intent, option, specialist, postVisit) => (
  dispatch,
  getState
) => {
  const { identifiers, simpleFlow } = getState()
  const { pov } = identifiers
  if (postVisit) {
    dispatch(setFollowUpSubmitted(true))
    setTimeout(() => {
      dispatch(showPostIntentPopUp(false))
    }, 2000)
  } else {
    dispatch(interviewActions.setLoading(true))
  }
  Source.submitUserIntent(intent, option, specialist, postVisit)
    .then(() => {
      dispatch(setUserIntent(intent))
      dispatch(setUserIntentCareOption(option))
      if (!postVisit && !simpleFlow.diagnosis) {
        dispatch(interviewActions.setLoading(false))
        // TODO: Remove the window variables after diagnosis of concern test is don
        if (window.d_concern_abcd === 2 || window.d_concern_abcd === 4) {
          dispatch(
            interviewActions.addChatItem(generator.dxocPromptQuestion(pov))
          )
        } else {
          dispatch(
            interviewActions.addChatItems([
              generator.systemMessage(dConcernHeader(pov)),
              generator.diagnosisConcern(window.d_concern_abcd === 3),
            ])
          )
        }
      } else {
        dispatch(interviewActions.setLoading(false))
        dispatch(resumeInterview())
      }
    })
    .catch(captureException)
}

export const searchFailure = () => (dispatch, getState) => {
  let { search, suggestions } = getState().search
  dispatch(setSubmitted(true))

  const textAsViewed = x => {
    let parts = suggestionText(x.text, search)
    return parts.before + parts.during + parts.after
  }

  tracker.suggestionMissing()

  Source.searchFailure(search, suggestions.items.map(textAsViewed).join(";"))
    .then(() => {
      dispatch(
        setSearchMsg(
          `No symptoms found matching: "${search}." Try using more general terms, and be sure to check your spelling.`
        )
      )
    })
    .catch(error => dispatch(interviewActions.genericError(error)))
}



// WEBPACK FOOTER //
// ./assets/search/actions.js